import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons"

import WizardHeader from "../components/WizardHeader"
import WizardCard from "../components/WizardCard"
import CaptionList from "../components/CaptionList"

const GetInTouch = () => {
  return (
    <div className="pt-10 lg:pt-13 pb-31">
      <WizardHeader
        heading="Get In Touch"
        text="Your property doesn't fit our standard coverage options. Our insurance specialists can help create a customized solution for your unique situation."
      />

      <div className="container w-[752px] max-w-full flex flex-col gap-6 px-5 lg:px-10 mt-10">
        <WizardCard paddingSize="sm">
          <div className="flex flex-col gap-6">
            <div className="w-14 h-14 flex justify-center items-center self-center text-leaf rounded-full bg-green-200">
              <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: 28 }} />
            </div>

            <h2 className="text-2xl text-center font-display font-medium leading-[124%] tracking-[0.48px]">
              Contact Our Insurance Team
            </h2>

            <div className="bg-cloud-300 border border-dusk-100 rounded py-6 text-center">
              <h3>Email us directly at:</h3>

              <p className="text-leaf text-2xl sm:text-3xl font-body font-bold break-all">
                landowners@ncx.com
              </p>
            </div>

            <p className="text-charcoal-500 text-base text-center font-body leading-[130%] tracking-[0.32px]">
              Send us an email with details about your property and insurance
              needs, and one of our specialists will get back to you within 1-2
              business days.
            </p>

            <div className="flex justify-center">
              <a
                href="mailto:landowners@ncx.com"
                className="btn2 btn2-primary font-semibold"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> Send
                Email
              </a>
            </div>
          </div>
        </WizardCard>

        <WizardCard paddingSize="sm">
          <CaptionList
            caption="What to include in your email"
            list={[
              <>
                <span className="font-semibold">Property Details:</span>{" "}
                location, size (acres), and number of parcels
              </>,
              <>
                <span className="font-semibold">Current Use:</span> Hunting
                leases, farming, commercial operations, etc.
              </>,
              <>
                <span className="font-semibold">Insurance Needs:</span> What
                type of coverage you're looking for
              </>,
              <>
                <span className="font-semibold">Contact Preference:</span> Best
                phone number and time to reach you
              </>,
              <>
                <span className="font-semibold">Questions:</span> Any specific
                concerns or requirements you have
              </>,
            ]}
            captionClass="!text-charcoal-500 !text-xl !font-display font-medium !leading-[130%] !tracking-[0.32px] mb-6"
            itemClass="!text-charcoal-500 !text-base !font-body !leading-[130%] !tracking-[0.32px] my-4"
          />
        </WizardCard>
      </div>
    </div>
  )
}

export default GetInTouch
